import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  categories: {
    minHeight: "calc(100vh - 64px)",
    width: "300px",
    padding: theme.spacing(4),
    textAlign: "right",
    fontSize: "1.05rem",
    borderRight: "1px solid",
    borderRightColor: theme.palette.divider,
    color: theme.palette.text.secondary
  },
  list: {
    position: "sticky",
    top: 64 + 4 * theme.spacing(1)
  },
  toCategory: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: "1px solid",
    borderBottomColor: theme.palette.divider,
    transition: "all 0.25s",
    cursor: "pointer",

    "&:hover": {
      color: theme.palette.text.primery
    },
    "&:last-child": {
      borderBottom: "none"
    }
  },
  current: {
    fontWeight: "500",
    color: theme.palette.primary.main
  }
}));

const Categories = ({ current, list, onSelect }) => {
  const classes = useStyles();

  return (
    <aside className={classes.categories}>
      <div className={classes.list}>
        {list.map((group, index) => (
          <div
            key={`category-${index}`}
            className={clsx(classes.toCategory, current === index ? classes.current : {})}
            onClick={() => onSelect(index)}
          >
            {group.label}
          </div>
        ))}
      </div>
    </aside>
  );
};

export default Categories;
